import { clsx } from 'clsx';
import styles from './SourceLabel.module.css';

const tierClass = {
  primary: styles.tierPrimary,
  secondary: styles.tierSecondary,
  corpus: styles.tierCorpus,
  fixture: styles.tierFixture,
} as const;

export function SourceLabel({
  source,
  tier = 'primary',
  knownAt,
}: {
  source: string;
  tier?: 'primary' | 'secondary' | 'corpus' | 'fixture';
  knownAt?: string;
}) {
  return (
    <span className={styles.root}>
      <span
        className={clsx(styles.tier, tierClass[tier])}
        aria-hidden="true"
      />
      <span>{source}</span>
      {knownAt && <time className={styles.time}>{knownAt}</time>}
    </span>
  );
}
